import { Controller } from 'stimulus';

const ANIMATION_TIMEOUT_MS = 100;

export default class extends Controller {
  static values = { boardsPaneOpenClass: String };
  static outlets = ['video-indicator'];

  #animationTimeout;

  adjustForBoardsPane(opened) {
    this.element.classList.toggle(this.boardsPaneOpenClassValue, opened);
  }

  keepOpen() {
    clearTimeout(this.#animationTimeout);
  }

  scheduleClose() {
    this.#animationTimeout = setTimeout(() => {
      this.videoIndicatorOutlet.close();
    }, ANIMATION_TIMEOUT_MS);
  }

  showVideoIndicator() {
    if (this.hasVideoIndicatorOutlet) {
      clearTimeout(this.#animationTimeout);
      this.videoIndicatorOutlet.show();
    }
  }

  hideVideoIndicator() {
    if (this.hasVideoIndicatorOutlet) {
      this.#animationTimeout = setTimeout(() => {
        this.videoIndicatorOutlet.close();
      }, ANIMATION_TIMEOUT_MS);
    }
  }
}
